export default __webpack_public_path__ + "static/media/cover.0ba7faea.jpeg";